/*
 * (c) Copyright Reserved EVRYTHNG Limited 2021. All rights reserved.
 * Use of this material is subject to license.
 * Copying and unauthorised use of this material strictly prohibited.
 */

/**
 * @returns {string}
 */
export default function getDefaultUrlFromQueryParams() {
  const { search: queryString } = window.location;

  const defaultUrlKeyString = 'defaultUrl=';
  const defaultUrlKeyIndex = queryString.indexOf(defaultUrlKeyString);

  if (!~defaultUrlKeyIndex) return '';

  const defaultUrlIndex = defaultUrlKeyIndex + defaultUrlKeyString.length;
  const defaultUrl = queryString.substring(defaultUrlIndex);

  return decodeURIComponent(defaultUrl);
}
